export const caseStudies = [
  {
    id: 1,
    slug: 'deluxe-restaurant-transformation',
    category: 'Restaurants',
    client: 'Deluxe Restaurant',
    industry: 'Food & Beverage',
    location: 'Tirana, Albania',
    projectDate: '2025',
    thumbnail: '/portfolio/restaurant-preview.jpg',
    heroImage: '/portfolio/restaurant-hero.jpg',
    liveUrl: 'https://restaurant-web-ten-phi.vercel.app',
    
    challenge: {
      sq: `
        <p>Deluxe Restaurant, një nga restorantet më prestigjoze në Tiranë, po përballen me sfida në botën dixhitale:</p>
        <ul>
          <li><strong>Zero Prezencë Online:</strong> Në 2025, restoranti nuk kishte asnjë website. Klientët e rinj nuk mund t'i gjenin ose të shihnin menynë përpara se të vinin.</li>
          <li><strong>Rezervime Telefonike:</strong> Gjithë procesi i rezervimeve bëhej me telefon, duke krijuar bottleneck dhe humbje potenciale klientësh.</li>
          <li><strong>Marketing i Kufizuar:</strong> Pa një platformë dixhitale, marketing-u ishte i kufizuar vetëm në word-of-mouth.</li>
          <li><strong>Konkurencë e Fortë:</strong> Restorante të tjerë me prezencë online po fitonin market share.</li>
        </ul>
      `,
      en: `
        <p>Deluxe Restaurant, one of Tirana's most prestigious restaurants, was facing digital challenges:</p>
        <ul>
          <li><strong>Zero Online Presence:</strong> In 2025, the restaurant had no website. New customers couldn't find them or see the menu before visiting.</li>
          <li><strong>Phone-Only Reservations:</strong> Entire booking process was via phone, creating bottlenecks and losing potential customers.</li>
          <li><strong>Limited Marketing:</strong> Without a digital platform, marketing was limited to word-of-mouth only.</li>
          <li><strong>Strong Competition:</strong> Other restaurants with online presence were gaining market share.</li>
        </ul>
      `
    },

    solution: {
      sq: `
        <p>Contenta Marketing projektoi dhe zhvilloi një website modern që adresonte të gjitha sfidat:</p>
        
        <h3>1. Design Premium që Reflekton Brandin</h3>
        <p>Kriojmë një design elegant me dark theme që reflekton sofistikimin e restorantit. Fotografi profesionale të ushqimit dhe ambientit, animacione smooth me Framer Motion, dhe përvoje përdoruesi e përsosur.</p>

        <h3>2. Menu Online Interaktive</h3>
        <p>Menuja e plotë është online me filtra sipas kategorisë (Appetizers, Main Course, Desserts, Drinks). Çdo pjatë ka foto, përshkrim të detajuar, dhe çmim. Update në kohë reale të disponueshmërisë.</p>

        <h3>3. Sistem Rezervimi Online 24/7</h3>
        <p>Klientët mund të rezervojnë tavolina direkt nga website-i në çdo kohë. Zgjedhin datën, orën, numrin e personave, dhe preferencat. Konfirmim automatik via email. Reduktim i ngarkesës për stafin.</p>

        <h3>4. Galeri Impresive</h3>
        <p>Showcase të ambientit, ushqimit, dhe event-eve speciale. Lightbox modern për viewing të foto në full screen. Instagram feed integration për social proof.</p>

        <h3>5. Google Maps Integration</h3>
        <p>Mapa interaktive që tregon lokacionin e saktë të restorantit. Directions direkt nga çdo pikë. Contact information i qartë.</p>

        <h3>6. Mobile-First & SEO Optimized</h3>
        <p>Website i përsosur në mobile (ku 70% e përdoruesve kërkojnë restorante). SEO optimized për keyword-e si "best restaurant Tirana", "fine dining Albania", etj.</p>

        <h3>7. Performance Maksimale</h3>
        <p>Load time vetëm 1.5 sekonda, Google PageSpeed score 92/100. Image optimization, lazy loading, dhe CDN për shpejtësi maksimale.</p>
      `,
      en: `
        <p>Contenta Marketing designed and developed a modern website that addressed all challenges:</p>
        
        <h3>1. Premium Design Reflecting the Brand</h3>
        <p>Created an elegant design with dark theme reflecting the restaurant's sophistication. Professional food and ambiance photography, smooth animations with Framer Motion, and perfect user experience.</p>

        <h3>2. Interactive Online Menu</h3>
        <p>Complete menu online with filters by category (Appetizers, Main Course, Desserts, Drinks). Each dish has photo, detailed description, and price. Real-time availability updates.</p>

        <h3>3. 24/7 Online Booking System</h3>
        <p>Customers can book tables directly from website anytime. Choose date, time, number of people, and preferences. Automatic confirmation via email. Reduced staff workload.</p>

        <h3>4. Impressive Gallery</h3>
        <p>Showcase of ambiance, food, and special events. Modern lightbox for full-screen photo viewing. Instagram feed integration for social proof.</p>

        <h3>5. Google Maps Integration</h3>
        <p>Interactive map showing exact restaurant location. Direct directions from any point. Clear contact information.</p>

        <h3>6. Mobile-First & SEO Optimized</h3>
        <p>Perfect website on mobile (where 70% of users search for restaurants). SEO optimized for keywords like "best restaurant Tirana", "fine dining Albania", etc.</p>

        <h3>7. Maximum Performance</h3>
        <p>Load time only 1.5 seconds, Google PageSpeed score 92/100. Image optimization, lazy loading, and CDN for maximum speed.</p>
      `
    },

    results: {
      metrics: [
        { label: { sq: 'Online Reservations', en: 'Online Reservations' }, value: '40%', description: { sq: 'e rezervimeve bëhen online', en: 'of bookings made online' } },
        { label: { sq: 'Website Traffic', en: 'Website Traffic' }, value: '2,500+', description: { sq: 'vizitor në muaj', en: 'visitors per month' } },
        { label: { sq: 'Google Ranking', en: 'Google Ranking' }, value: '#1', description: { sq: 'për "fine dining Tirana"', en: 'for "fine dining Tirana"' } },
        { label: { sq: 'Load Time', en: 'Load Time' }, value: '1.5s', description: { sq: 'kohë ngarkimi mesatare', en: 'average load time' } },
        { label: { sq: 'Mobile Traffic', en: 'Mobile Traffic' }, value: '68%', description: { sq: 'e vizitorëve nga mobile', en: 'of visitors from mobile' } },
        { label: { sq: 'Conversion Rate', en: 'Conversion Rate' }, value: '12%', description: { sq: 'nga visitor në rezervim', en: 'from visitor to booking' } }
      ],
      
      testimonial: {
        sq: `"Bashkëpunimi me Contenta Marketing ka qenë transformues për biznesin tonë. Website-i nuk është vetëm i bukur - ai është një makinë rezervimesh. Tani 40% e rezervimeve vijnë direkt online, duke liruar stafin tonë për të fokusuar në kualitetin e shërbimit. Traffic-u nga Google ka eksploduar, dhe jemi #1 për keyword-et kryesore. ROI ishte i menjëhershëm."`,
        en: `"The collaboration with Contenta Marketing has been transformative for our business. The website isn't just beautiful - it's a booking machine. Now 40% of reservations come directly online, freeing our staff to focus on service quality. Google traffic has exploded, and we're #1 for key keywords. ROI was immediate."`,
        author: 'Altin Berisha',
        position: { sq: 'Pronar, Deluxe Restaurant', en: 'Owner, Deluxe Restaurant' }
      },

      timeline: {
        sq: [
          { phase: 'Discovery & Planning', duration: '1 javë', description: 'Brand analysis, competitor research, feature planning' },
          { phase: 'Design & Prototyping', duration: '2 javë', description: 'Wireframes, mockups, client feedback rounds' },
          { phase: 'Development', duration: '3 javë', description: 'Frontend, backend, booking system integration' },
          { phase: 'Testing & Launch', duration: '1 javë', description: 'QA testing, performance optimization, SEO setup' },
          { phase: 'Post-Launch Support', duration: 'Ongoing', description: 'Monitoring, updates, optimization' }
        ],
        en: [
          { phase: 'Discovery & Planning', duration: '1 week', description: 'Brand analysis, competitor research, feature planning' },
          { phase: 'Design & Prototyping', duration: '2 weeks', description: 'Wireframes, mockups, client feedback rounds' },
          { phase: 'Development', duration: '3 weeks', description: 'Frontend, backend, booking system integration' },
          { phase: 'Testing & Launch', duration: '1 week', description: 'QA testing, performance optimization, SEO setup' },
          { phase: 'Post-Launch Support', duration: 'Ongoing', description: 'Monitoring, updates, optimization' }
        ]
      }
    },

    techStack: [
      { name: 'React', purpose: 'UI Library' },
      { name: 'Next.js', purpose: 'Framework & SSR' },
      { name: 'Tailwind CSS', purpose: 'Styling' },
      { name: 'Framer Motion', purpose: 'Animations' },
      { name: 'Google Maps API', purpose: 'Location Integration' },
      { name: 'EmailJS', purpose: 'Booking Notifications' },
      { name: 'Vercel', purpose: 'Hosting & Deployment' }
    ],

    keyFeatures: [
      { 
        icon: 'Menu', 
        title: { sq: 'Menu Dixhital', en: 'Digital Menu' },
        description: { sq: 'Menuja e plotë online me foto dhe filtra', en: 'Complete menu online with photos and filters' }
      },
      { 
        icon: 'Calendar', 
        title: { sq: 'Rezervime Online', en: 'Online Bookings' },
        description: { sq: 'Sistem rezervimi 24/7 me konfirmim automatik', en: '24/7 booking system with automatic confirmation' }
      },
      { 
        icon: 'Image', 
        title: { sq: 'Galeri Premium', en: 'Premium Gallery' },
        description: { sq: 'Showcase fotosh profesionale të ushqimit dhe ambientit', en: 'Professional photo showcase of food and ambiance' }
      },
      { 
        icon: 'MapPin', 
        title: { sq: 'Google Maps', en: 'Google Maps' },
        description: { sq: 'Mapa interaktive dhe directions', en: 'Interactive map and directions' }
      },
      { 
        icon: 'Smartphone', 
        title: { sq: 'Mobile Perfect', en: 'Mobile Perfect' },
        description: { sq: 'Design i optimizuar për celular', en: 'Mobile-optimized design' }
      },
      { 
        icon: 'Zap', 
        title: { sq: 'Super Shpejt', en: 'Super Fast' },
        description: { sq: '1.5s load time, score 92/100', en: '1.5s load time, score 92/100' }
      }
    ],

    gallery: [
      '/portfolio/restaurant-home.jpg',
      '/portfolio/restaurant-menu.jpg',
      '/portfolio/restaurant-gallery.jpg',
      '/portfolio/restaurant-booking.jpg',
      '/portfolio/restaurant-contact.jpg'
    ]
  },

  {
    id: 2,
    slug: 'ecommerce-platform-growth',
    category: 'E-Commerce',
    client: 'Fashion House Albania',
    industry: 'E-Commerce / Fashion',
    location: 'Albania',
    projectDate: '2025',
    thumbnail: '/portfolio/ecommerce-preview.jpg',
    heroImage: '/portfolio/ecommerce-hero.jpg',
    liveUrl: '#',
    
    challenge: {
      sq: `
        <p>Fashion House Albania, një brand i ri fashion, dëshironte të hynte në e-commerce por pa experience dhe me budget të kufizuar:</p>
        <ul>
          <li><strong>Zero Infrastrukturë E-Commerce:</strong> Asnjë platform ekzistuese, asnjë sistem pagese, asnjë inventory management.</li>
          <li><strong>Konkurencë e Fortë:</strong> Tregu i fashion online në Shqipëri është shumë konkurues me players të mëdhenj.</li>
          <li><strong>Trust Issue:</strong> Klientët shqiptarë janë skeptikë për blerje online, veçanërisht nga brands të reja.</li>
          <li><strong>Logistics Komplekse:</strong> Dërgesa në të gjithë Shqipërinë, returns policy, inventory tracking.</li>
          <li><strong>Budget i Kufizuar:</strong> Startup me budget të kufizuar por expectations të larta për ROI.</li>
        </ul>
      `,
      en: `
        <p>Fashion House Albania, a new fashion brand, wanted to enter e-commerce but with no experience and limited budget:</p>
        <ul>
          <li><strong>Zero E-Commerce Infrastructure:</strong> No existing platform, no payment system, no inventory management.</li>
          <li><strong>Strong Competition:</strong> Albania's online fashion market is very competitive with major players.</li>
          <li><strong>Trust Issues:</strong> Albanian customers are skeptical about online purchases, especially from new brands.</li>
          <li><strong>Complex Logistics:</strong> Shipping across Albania, returns policy, inventory tracking.</li>
          <li><strong>Limited Budget:</strong> Startup with limited budget but high ROI expectations.</li>
        </ul>
      `
    },

    solution: {
      sq: `
        <p>Ndërtuam një e-commerce platform të plotë që adresonte çdo sfidë:</p>
        
        <h3>1. Custom E-Commerce Platform</h3>
        <p>Ndërtuam nga zero një platform e-commerce me React dhe Shopify backend. Admin panel për inventory management, order tracking, customer management. Responsive design i përsosur për mobile shopping.</p>

        <h3>2. Trust-Building Features</h3>
        <p>Integruam reviews & ratings system, showcase social proof, "30-Day Money Back Guarantee", SSL certificate për siguri, showcase te delivery partners të njohur. Photos profesionale të produkteve nga shumë kënde.</p>

        <h3>3. Payment Flexibility</h3>
        <p>Ofrojmë shumë metoda pagese: kartë krediti/debiti, PayPal, cash on delivery (key për market shqiptar). Payment gateway i sigurt me enkriptim. Split payment opsion për blerje të mëdha.</p>

        <h3>4. Smart Product Filtering</h3>
        <p>Advanced search me filter për: size, color, price range, brand, category, popularity. Sort by: price, newest, most popular. Instant search results. Related products recommendations.</p>

        <h3>5. Cart Recovery System</h3>
        <p>Email automation për cart abandonment (15% recovery rate). Exit intent popup me exclusive discount. Wishlist feature për future purchases.</p>

        <h3>6. Logistics Integration</h3>
        <p>Integration me Posta Shqiptare dhe private couriers. Real-time shipping cost calculation. Order tracking system. Automated shipping labels generation.</p>

        <h3>7. Marketing Automation</h3>
        <p>Email marketing automation: welcome series, order confirmations, shipping updates, review requests. Facebook Pixel për retargeting. Instagram shopping integration.</p>

        <h3>8. Analytics Dashboard</h3>
        <p>Real-time dashboard për sales, traffic, conversion rate, top products, customer behavior. Google Analytics integration për deep insights.</p>
      `,
      en: `
        <p>Built a complete e-commerce platform that addressed every challenge:</p>
        
        <h3>1. Custom E-Commerce Platform</h3>
        <p>Built from scratch an e-commerce platform with React and Shopify backend. Admin panel for inventory management, order tracking, customer management. Perfect responsive design for mobile shopping.</p>

        <h3>2. Trust-Building Features</h3>
        <p>Integrated reviews & ratings system, social proof showcase, "30-Day Money Back Guarantee", SSL certificate for security, showcase of known delivery partners. Professional product photos from multiple angles.</p>

        <h3>3. Payment Flexibility</h3>
        <p>Offer multiple payment methods: credit/debit card, PayPal, cash on delivery (key for Albanian market). Secure payment gateway with encryption. Split payment option for large purchases.</p>

        <h3>4. Smart Product Filtering</h3>
        <p>Advanced search with filters for: size, color, price range, brand, category, popularity. Sort by: price, newest, most popular. Instant search results. Related product recommendations.</p>

        <h3>5. Cart Recovery System</h3>
        <p>Email automation for cart abandonment (15% recovery rate). Exit intent popup with exclusive discount. Wishlist feature for future purchases.</p>

        <h3>6. Logistics Integration</h3>
        <p>Integration with Albanian Post and private couriers. Real-time shipping cost calculation. Order tracking system. Automated shipping label generation.</p>

        <h3>7. Marketing Automation</h3>
        <p>Email marketing automation: welcome series, order confirmations, shipping updates, review requests. Facebook Pixel for retargeting. Instagram shopping integration.</p>

        <h3>8. Analytics Dashboard</h3>
        <p>Real-time dashboard for sales, traffic, conversion rate, top products, customer behavior. Google Analytics integration for deep insights.</p>
      `
    },

    results: {
      metrics: [
        { label: { sq: 'Monthly Revenue', en: 'Monthly Revenue' }, value: '€25,000+', description: { sq: 'nga €0 në 6 muaj', en: 'from €0 in 6 months' } },
        { label: { sq: 'Orders per Month', en: 'Orders per Month' }, value: '450+', description: { sq: 'mesatarisht', en: 'on average' } },
        { label: { sq: 'Conversion Rate', en: 'Conversion Rate' }, value: '3.2%', description: { sq: 'mbi mesataren e industrisë', en: 'above industry average' } },
        { label: { sq: 'Average Order Value', en: 'Average Order Value' }, value: '€55', description: { sq: 'AOV', en: 'AOV' } },
        { label: { sq: 'Customer Retention', en: 'Customer Retention' }, value: '35%', description: { sq: 'blejnë përsëri', en: 'repeat purchases' } },
        { label: { sq: 'Cart Recovery', en: 'Cart Recovery' }, value: '15%', description: { sq: 'recovered carts', en: 'recovered carts' } }
      ],
      
      testimonial: {
        sq: `"Contenta Marketing e transformoi idenë tonë në një biznes real e-commerce. Në 6 muaj, arritëm €25,000 revenue mujor - më shumë sesa prisnim për vitin e parë të tërë. Platform-a është intuitive, admin panel-i na kursen orë çdo ditë, dhe conversion rate është jashtëzakonshëm. Email automation vetëm recovered 15% të cart abandonments, që është revenue direkt. Best investment që kemi bërë."`,
        en: `"Contenta Marketing transformed our idea into a real e-commerce business. In 6 months, we reached €25,000 monthly revenue - more than we expected for the entire first year. The platform is intuitive, the admin panel saves us hours daily, and the conversion rate is exceptional. Email automation alone recovered 15% of cart abandonments, which is direct revenue. Best investment we've made."`,
        author: 'Elira Hoxha',
        position: { sq: 'Founder, Fashion House Albania', en: 'Founder, Fashion House Albania' }
      },

      timeline: {
        sq: [
          { phase: 'Research & Planning', duration: '2 javë', description: 'Market research, competitor analysis, feature prioritization' },
          { phase: 'Design & Branding', duration: '3 javë', description: 'Brand identity, UI/UX design, mockups' },
          { phase: 'Platform Development', duration: '6 javë', description: 'Frontend, backend, payment integration, admin panel' },
          { phase: 'Testing & Optimization', duration: '2 javë', description: 'QA, performance testing, security audit' },
          { phase: 'Launch & Marketing', duration: '1 javë', description: 'Soft launch, marketing campaigns, SEO' },
          { phase: 'Ongoing Support', duration: 'Ongoing', description: 'Maintenance, updates, optimization, consulting' }
        ],
        en: [
          { phase: 'Research & Planning', duration: '2 weeks', description: 'Market research, competitor analysis, feature prioritization' },
          { phase: 'Design & Branding', duration: '3 weeks', description: 'Brand identity, UI/UX design, mockups' },
          { phase: 'Platform Development', duration: '6 weeks', description: 'Frontend, backend, payment integration, admin panel' },
          { phase: 'Testing & Optimization', duration: '2 weeks', description: 'QA, performance testing, security audit' },
          { phase: 'Launch & Marketing', duration: '1 week', description: 'Soft launch, marketing campaigns, SEO' },
          { phase: 'Ongoing Support', duration: 'Ongoing', description: 'Maintenance, updates, optimization, consulting' }
        ]
      }
    },

    techStack: [
      { name: 'React', purpose: 'Frontend Framework' },
      { name: 'Node.js', purpose: 'Backend API' },
      { name: 'MongoDB', purpose: 'Database' },
      { name: 'Stripe', purpose: 'Payment Processing' },
      { name: 'Shopify', purpose: 'E-Commerce Backend' },
      { name: 'SendGrid', purpose: 'Email Automation' },
      { name: 'AWS S3', purpose: 'Image Storage' },
      { name: 'Cloudflare', purpose: 'CDN & Security' }
    ],

    keyFeatures: [
      { 
        icon: 'ShoppingCart', 
        title: { sq: 'Smart Cart', en: 'Smart Cart' },
        description: { sq: 'Cart recovery, wishlist, quick checkout', en: 'Cart recovery, wishlist, quick checkout' }
      },
      { 
        icon: 'CreditCard', 
        title: { sq: 'Payment Flexibility', en: 'Payment Flexibility' },
        description: { sq: 'Card, PayPal, cash on delivery', en: 'Card, PayPal, cash on delivery' }
      },
      { 
        icon: 'Search', 
        title: { sq: 'Advanced Filters', en: 'Advanced Filters' },
        description: { sq: 'Search by size, color, price, brand', en: 'Search by size, color, price, brand' }
      },
      { 
        icon: 'Star', 
        title: { sq: 'Reviews System', en: 'Reviews System' },
        description: { sq: 'Customer reviews & ratings', en: 'Customer reviews & ratings' }
      },
      { 
        icon: 'Truck', 
        title: { sq: 'Order Tracking', en: 'Order Tracking' },
        description: { sq: 'Real-time tracking & updates', en: 'Real-time tracking & updates' }
      },
      { 
        icon: 'Mail', 
        title: { sq: 'Email Automation', en: 'Email Automation' },
        description: { sq: 'Welcome, orders, recovery emails', en: 'Welcome, orders, recovery emails' }
      }
    ],

    gallery: [
      '/portfolio/ecommerce-home.jpg',
      '/portfolio/ecommerce-products.jpg',
      '/portfolio/ecommerce-product-detail.jpg',
      '/portfolio/ecommerce-cart.jpg',
      '/portfolio/ecommerce-admin.jpg'
    ]
  },

  {
    id: 3,
    slug: 'real-estate-lead-generation',
    category: 'Real Estate',
    client: 'Prime Properties',
    industry: 'Real Estate',
    location: 'Tirana, Albania',
    projectDate: '2025',
    thumbnail: '/portfolio/realestate-preview.jpg',
    heroImage: '/portfolio/realestate-hero.jpg',
    liveUrl: '#',
    
    challenge: {
      sq: `
        <p>Prime Properties, një agjenci e re real estate në Tiranë, po luftonte për të konkuruar me agjencitë e mëdha:</p>
        <ul>
          <li><strong>Lead Generation i Dobët:</strong> Vetëm 5-10 leads në muaj, kryesisht nga referrals.</li>
          <li><strong>Website i Vjetëruar:</strong> Website ekzistues ishte i ngadaltë, jo mobile-friendly, dhe pa features moderne.</li>
          <li><strong>Zero Automatizim:</strong> Gjithçka bëhej manually - komunikim me klientë, property listings, follow-ups.</li>
          <li><strong>Branding i Dobët:</strong> Brand identity i pa qartë që nuk i dallonte nga konkurentët.</li>
          <li><strong>High Competition:</strong> Tirana ka qindra agjenci real estate që konkurrojnë për të njëjtët klientë.</li>
        </ul>
      `,
      en: `
        <p>Prime Properties, a new real estate agency in Tirana, was struggling to compete with large agencies:</p>
        <ul>
          <li><strong>Weak Lead Generation:</strong> Only 5-10 leads per month, mostly from referrals.</li>
          <li><strong>Outdated Website:</strong> Existing website was slow, not mobile-friendly, and lacked modern features.</li>
          <li><strong>Zero Automation:</strong> Everything done manually - client communication, property listings, follow-ups.</li>
          <li><strong>Weak Branding:</strong> Unclear brand identity that didn't differentiate from competitors.</li>
          <li><strong>High Competition:</strong> Tirana has hundreds of real estate agencies competing for the same clients.</li>
        </ul>
      `
    },

    solution: {
      sq: `
        <p>Kriojmë një strategji dixhitale 360° që transformoi biznesin:</p>
        
        <h3>1. Brand Identity e Re</h3>
        <p>Zhvilluam një brand identity moderne dhe profesionale: logo e re, color palette, typography, brand guidelines. Positioning si agjencia premium për buyers të sofistikuar.</p>

        <h3>2. Website Lead-Generation Machine</h3>
        <p>Ndërtuam një website që fokus primar ka lead generation:</p>
        <ul>
          <li>Advanced property search me 15+ filtra (location, price, size, type, etj)</li>
          <li>Property comparison tool (side-by-side comparison)</li>
          <li>Interactive map view me clustering</li>
          <li>Virtual tours dhe 360° photos</li>
          <li>Mortgage calculator tool</li>
          <li>Instant property valuation form</li>
          <li>Live chat për pyetje të menjëhershme</li>
        </ul>

        <h3>3. CRM Integration & Automation</h3>
        <p>Integruam HubSpot CRM për lead management:</p>
        <ul>
          <li>Automatic lead capture nga të gjitha burimet</li>
          <li>Lead scoring based on behavior</li>
          <li>Automated email sequences për nurturing</li>
          <li>Task automation për follow-ups</li>
          <li>Analytics dashboard për performance tracking</li>
        </ul>

        <h3>4. SEO & Content Marketing</h3>
        <p>Aggressive SEO strategy për të dominuar local search:</p>
        <ul>
          <li>Target 50+ real estate keywords</li>
          <li>Neighborhood guides (20+ artikuj)</li>
          <li>Buying/selling guides</li>
          <li>Market reports (monthly)</li>
          <li>Property showcases</li>
          <li>Google My Business optimization</li>
        </ul>

        <h3>5. Paid Ads Campaigns</h3>
        <p>Multi-channel paid strategy:</p>
        <ul>
          <li>Google Ads për high-intent keywords</li>
          <li>Facebook/Instagram Ads për property showcases</li>
          <li>Retargeting për website visitors</li>
          <li>YouTube video ads</li>
        </ul>

        <h3>6. Social Media Strategy</h3>
        <p>Konsistent content calendar me:</p>
        <ul>
          <li>Property showcases (3x/week)</li>
          <li>Market insights (2x/week)</li>
          <li>Client testimonials (1x/week)</li>
          <li>Behind-the-scenes content</li>
          <li>Live Q&A sessions (weekly)</li>
        </ul>

        <h3>7. Email Marketing</h3>
        <p>Segmented email campaigns:</p>
        <ul>
          <li>New listings alerts</li>
          <li>Price drop notifications</li>
          <li>Market updates newsletter</li>
          <li>Educational content for buyers/sellers</li>
        </ul>
      `,
      en: `
        <p>Created a 360° digital strategy that transformed the business:</p>
        
        <h3>1. New Brand Identity</h3>
        <p>Developed a modern and professional brand identity: new logo, color palette, typography, brand guidelines. Positioning as premium agency for sophisticated buyers.</p>

        <h3>2. Website Lead-Generation Machine</h3>
        <p>Built a website with primary focus on lead generation:</p>
        <ul>
          <li>Advanced property search with 15+ filters (location, price, size, type, etc)</li>
          <li>Property comparison tool (side-by-side comparison)</li>
          <li>Interactive map view with clustering</li>
          <li>Virtual tours and 360° photos</li>
          <li>Mortgage calculator tool</li>
          <li>Instant property valuation form</li>
          <li>Live chat for immediate questions</li>
        </ul>

        <h3>3. CRM Integration & Automation</h3>
        <p>Integrated HubSpot CRM for lead management:</p>
        <ul>
          <li>Automatic lead capture from all sources</li>
          <li>Lead scoring based on behavior</li>
          <li>Automated email sequences for nurturing</li>
          <li>Task automation for follow-ups</li>
          <li>Analytics dashboard for performance tracking</li>
        </ul>

        <h3>4. SEO & Content Marketing</h3>
        <p>Aggressive SEO strategy to dominate local search:</p>
        <ul>
          <li>Target 50+ real estate keywords</li>
          <li>Neighborhood guides (20+ articles)</li>
          <li>Buying/selling guides</li>
          <li>Market reports (monthly)</li>
          <li>Property showcases</li>
          <li>Google My Business optimization</li>
        </ul>

        <h3>5. Paid Ads Campaigns</h3>
        <p>Multi-channel paid strategy:</p>
        <ul>
          <li>Google Ads for high-intent keywords</li>
          <li>Facebook/Instagram Ads for property showcases</li>
          <li>Retargeting for website visitors</li>
          <li>YouTube video ads</li>
        </ul>

        <h3>6. Social Media Strategy</h3>
        <p>Consistent content calendar with:</p>
        <ul>
          <li>Property showcases (3x/week)</li>
          <li>Market insights (2x/week)</li>
          <li>Client testimonials (1x/week)</li>
          <li>Behind-the-scenes content</li>
          <li>Live Q&A sessions (weekly)</li>
        </ul>

        <h3>7. Email Marketing</h3>
        <p>Segmented email campaigns:</p>
        <ul>
          <li>New listings alerts</li>
          <li>Price drop notifications</li>
          <li>Market updates newsletter</li>
          <li>Educational content for buyers/sellers</li>
        </ul>
      `
    },

    results: {
      metrics: [
        { label: { sq: 'Monthly Leads', en: 'Monthly Leads' }, value: '120+', description: { sq: 'nga 5-10 leads', en: 'from 5-10 leads' } },
        { label: { sq: 'Conversion Rate', en: 'Conversion Rate' }, value: '8.5%', description: { sq: 'nga lead në klient', en: 'from lead to client' } },
        { label: { sq: 'Website Traffic', en: 'Website Traffic' }, value: '+650%', description: { sq: 'increase në 6 muaj', en: 'increase in 6 months' } },
        { label: { sq: 'Google Rankings', en: 'Google Rankings' }, value: '15', description: { sq: 'keywords në top 3', en: 'keywords in top 3' } },
        { label: { sq: 'Cost Per Lead', en: 'Cost Per Lead' }, value: '€12', description: { sq: 'mesatarisht', en: 'on average' } },
        { label: { sq: 'Revenue Growth', en: 'Revenue Growth' }, value: '+280%', description: { sq: 'në vitin e parë', en: 'in first year' } }
      ],
      
      testimonial: {
        sq: `"Rezultatet janë përtej çdo pritje. Nga 5-10 leads në muaj në 120+. Conversion rate është 8.5% - më e lartë se mesatarja e industrisë. Website-i është një tool i fuqishëm shitjeje që punon 24/7. CRM automation na ka kursyer orë të pafund, dhe SEO na ka sjellë në top të Google për keywords që importojnë. Në vitin e parë, revenue u rrit 280%. Contenta Marketing nuk është thjesht një agjenci - janë një partner strategjik."`,
        en: `"The results are beyond any expectations. From 5-10 leads per month to 120+. Conversion rate is 8.5% - higher than industry average. The website is a powerful sales tool that works 24/7. CRM automation has saved us countless hours, and SEO has brought us to the top of Google for keywords that matter. In the first year, revenue grew 280%. Contenta Marketing isn't just an agency - they're a strategic partner."`,
        author: 'Ervin Dervishi',
        position: { sq: 'CEO, Prime Properties', en: 'CEO, Prime Properties' }
      },

      timeline: {
        sq: [
          { phase: 'Discovery & Strategy', duration: '2 javë', description: 'Market research, competitor analysis, strategy development' },
          { phase: 'Branding', duration: '2 javë', description: 'Brand identity, visual design, guidelines' },
          { phase: 'Website Development', duration: '5 javë', description: 'Design, development, CRM integration' },
          { phase: 'Content Creation', duration: '4 javë', description: '20 articles, property descriptions, guides' },
          { phase: 'SEO & Launch', duration: '2 javë', description: 'On-page SEO, technical SEO, soft launch' },
          { phase: 'Marketing Campaigns', duration: 'Month 2-3', description: 'Paid ads, social media, email marketing' },
          { phase: 'Optimization', duration: 'Ongoing', description: 'A/B testing, conversion optimization, scaling' }
        ],
        en: [
          { phase: 'Discovery & Strategy', duration: '2 weeks', description: 'Market research, competitor analysis, strategy development' },
          { phase: 'Branding', duration: '2 weeks', description: 'Brand identity, visual design, guidelines' },
          { phase: 'Website Development', duration: '5 weeks', description: 'Design, development, CRM integration' },
          { phase: 'Content Creation', duration: '4 weeks', description: '20 articles, property descriptions, guides' },
          { phase: 'SEO & Launch', duration: '2 weeks', description: 'On-page SEO, technical SEO, soft launch' },
          { phase: 'Marketing Campaigns', duration: 'Month 2-3', description: 'Paid ads, social media, email marketing' },
          { phase: 'Optimization', duration: 'Ongoing', description: 'A/B testing, conversion optimization, scaling' }
        ]
      }
    },

    techStack: [
      { name: 'React', purpose: 'Frontend Framework' },
      { name: 'Next.js', purpose: 'SSR & SEO' },
      { name: 'Tailwind CSS', purpose: 'Styling' },
      { name: 'Google Maps API', purpose: 'Property Maps' },
      { name: 'HubSpot CRM', purpose: 'Lead Management' },
      { name: 'Mailchimp', purpose: 'Email Marketing' },
      { name: 'Cloudinary', purpose: 'Image Management' },
      { name: 'Vercel', purpose: 'Hosting' }
    ],

    keyFeatures: [
      { 
        icon: 'Search', 
        title: { sq: 'Advanced Search', en: 'Advanced Search' },
        description: { sq: '15+ filtra për property search', en: '15+ filters for property search' }
      },
      { 
        icon: 'MapPin', 
        title: { sq: 'Interactive Maps', en: 'Interactive Maps' },
        description: { sq: 'Map view me clustering & filters', en: 'Map view with clustering & filters' }
      },
      { 
        icon: 'Eye', 
        title: { sq: 'Virtual Tours', en: 'Virtual Tours' },
        description: { sq: '360° photos & video tours', en: '360° photos & video tours' }
      },
      { 
        icon: 'Calculator', 
        title: { sq: 'Mortgage Calculator', en: 'Mortgage Calculator' },
        description: { sq: 'Llogarit pagesa mujore', en: 'Calculate monthly payments' }
      },
      { 
        icon: 'MessageCircle', 
        title: { sq: 'Live Chat', en: 'Live Chat' },
        description: { sq: 'Chat në kohë reale me agjentë', en: 'Real-time chat with agents' }
      },
      { 
        icon: 'BarChart', 
        title: { sq: 'CRM Integration', en: 'CRM Integration' },
        description: { sq: 'Lead tracking & automation', en: 'Lead tracking & automation' }
      }
    ],

    gallery: [
      '/portfolio/realestate-home.jpg',
      '/portfolio/realestate-search.jpg',
      '/portfolio/realestate-property.jpg',
      '/portfolio/realestate-map.jpg',
      '/portfolio/realestate-dashboard.jpg'
    ]
  }
]